import React, { Fragment } from 'react';

import HtmlInput from '../html/Input';

import { withLabel } from '../Label';
import InputError from '../errors/InputError';

export const EmailInput = ({
  Input = HtmlInput,
  Error = InputError,
  autoFocus,
  value,
  onChange,
  isDisabled,
  name = 'email',
  error,
  hasError,
  ...rest
}) => (
  <Fragment>
    <Input
      id={name}
      type="email"
      name={name}
      autoComplete="email"
      autoCapitalize="off"
      autoCorrect="off"
      placeholder="e.g., dr.lawson@hospital.com"
      autoFocus={autoFocus || false}
      value={value || ''}
      onChange={e => onChange(e.target.value)}
      disabled={isDisabled}
      hasError={hasError}
      {...rest}
      multiple
    />
    <Error isVisible={hasError} id={name}>
      {hasError ? error : ''}
    </Error>
  </Fragment>
);

export default withLabel('Email Address')(EmailInput);
